<template>
    <div id="enhance-composer">
        <div class="col-md-4"
             v-bind:class="{'col-md-offset-3': diff.length === 0,
                            'col-md-6': diff.length === 0,
                            'col-md-4': diff.length > 0,
                            'col-md-offset-2': diff.length > 0}">
            <notifications position="top left" animation-type="velocity" />
            <p class="text-center">
                <textarea v-model="message" class="form-control" rows="4"></textarea>
            </p>
            <p v-for="image in images">
                <a :href="image.url" data-lity>
                    <img class="img-thumbnail image" :src="image.url">
                </a>
            </p>
            <div class="pull-right">
                <small class="total-enhanced">
                    Posts enhanced:<br>
                    <span :class="{'text-danger': limit.remain == 0}">{{ limit.used }}</span> /
                    <span :class="{'text-danger': limit.remain == 0}">{{ limit.limit }}</span>
                    <i class="fa fa-info-circle text-success hint" :data-original-title="billingHint"></i>
                    <b-tooltip text="Please upgrade to keep enhancing" placement="bottom" trigger="manual" v-model="showUpgradeTooltip">
                        <a href="//ritekit.com/pricing" target="_blank" class="btn btn-xs btn-default" :class="{'btn-primary': limit.remain===0}">
                            <i class="fa fa-star"></i> Upgrade
                        </a>
                    </b-tooltip>
                </small>
            </div>
            <div class="btn-group auto-enhance-group">
                <button @click="enhance" class="btn btn-primary hint"
                        data-container="body"
                        data-original-title="Open the dropdown for detailed settings">
                    <i v-if="loading" class='fa fa-spinner fa-spin'></i>
                    <i v-else="" class="fa fa-magic"></i>
                    Enhance
                </button>
                <button class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                    <span class="caret"></span>
                </button>
                <enhance-dropdown ref="dropdown"/>
            </div>
            <div class="clearfix"></div>
            <p>
                <img class="arrow-top" src="./../../www/assets/img/common/arrow-signup.png">
                Open to fine-tune settings
            </p>
        </div>
        <div class="col-md-4 results-panel" v-if="diff.length > 0">
            <span v-for="item in diff">
                <span v-if="item.text">{{item.text.trim()}}</span>
                <span v-if="item.remove" class="remove-text">{{item.remove.trim()}}</span>
                <span v-if="item.add" class="add-text">{{item.add.trim()}}</span>
                <span v-if="item.add">&nbsp;</span> <!-- Add spaces-->
            </span>
            <div class="enhance-options">
                <ul>
                    <li class="checked" v-for="option in enhanceCheckedOptions">{{option.title}}&nbsp;
                        <b-tooltip :text="setTooltip(option)">
                            <i class="fa fa-info-circle text-success hint option-info-tooltip"></i>
                        </b-tooltip>
                    </li>
                    <li class="crossed" v-for="option in enhanceCrossedOptions">{{option.notFoundTitle}}&nbsp;
                        <b-tooltip :text="setTooltip(option)">
                            <i class="fa fa-info-circle text-success hint option-info-tooltip"></i>
                        </b-tooltip>
                    </li>
                    <li class="revert"><a @click="revertEnhancedPost">Revert to original</a></li>
                    <li v-if="linkWarning" class="text-danger error">This site blocks ads. Your ad won't show.</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import EnhanceDropdown from './components/EnhanceDropdown'
    import worddiff from 'word-diff'
    export default {
        name: 'EnhanceComposer',
        components: {
            EnhanceDropdown
        },
        data () {
            return {
                message: 'Twitter Fleets have created a whole new opportunity for reply guys ' +
                    'https://mashable.com/article/twitter-fleet-reply-guys/',
                originalMessage: '',
                images: [],
                diff: [],
                linkWarning: false,
                enhanceCheckedOptions: [],
                enhanceCrossedOptions: [],
                enhanceOptionsInfo: {
                    extractImage: {
                        title: 'Image extracted',
                        notFoundTitle: 'No Images found',
                        tooltip: 'Automatically attaches an image extracted from meta tags in a link in your post.',
                        tooltipWhy: 'Link images draw attention to your post.'
                    },
                    autoHashtags: {
                        title: 'Hashtags added',
                        notFoundTitle: 'No Hashtags found',
                        tooltip: 'Adds 2-3 hashtags to your post by analyzing its content. The longer the text, the better the results.',
                        tooltipWhy: 'Hashtags increase post reach & engagement.'
                    },
                    autoEmoji: {
                        title: 'Emoji added',
                        notFoundTitle: 'No Emojis found',
                        tooltip: 'Automatically add relevant emojis to your post.',
                        tooltipWhy: 'Emojis significantly increase engagement.'
                    },
                    shortLink: {
                        title: 'Ad placed on link',
                        tooltip: 'Automatically shortens links with a button, image or video ad. One ad style included in RiteBoost,' +
                        'more can be purchased at Rite.ly. Full branding including custom domains, too.',
                        tooltipWhy: 'Ads on links promote your brand on all content you share'
                    },
                    twitterHandler: {
                        title: 'Author attributed',
                        tooltip: 'Automatically @mention author of an article extracted from link meta data.',
                        tooltipWhy: 'Mentioning author of an article increases engagement & reach of your post'
                    }
                },
                loading: false,
                showUpgradeTooltip: false,
                billingPeriod: '1st',
                limit: {
                    used: 0,
                    limit: 0,
                    remain: 1
                }
            }
        },
        watch: {
            limit (limit) {
                if (limit.remain === 0) {
                    this.showUpgradeTooltip = true
                }
            }
        },
        computed: {
            billingHint () {
                return `Billing cycle resets each month on the ${this.billingPeriod}`
            }
        },
        created () {
            axios.get('/api/v1/user/limit?server=boost').then((response) => {
                this.limit = response.data.limit
            })
        },
        methods: {
            enhance () {
                const self = this
                self.loading = true
                const child = this.$refs.dropdown
                const options = child.getEnhanceOptions()
                options.post = this.message
                axios.get('/api/v2/enhance', {params: options}).then((response) => {
                    self.loading = false
                    const json = response.data
                    console.log(response.data)
                    self.originalMessage = self.message
                    self.message = json.post
                    self.compareMessages()
                    self.images = json.images
                    self.enhanceCrossedOptions = []
                    if (options.extractImage && json.images.length === 0) {
                        this.enhanceCrossedOptions.push(self.enhanceOptionsInfo.extractImage)
                        options.extractImage = false
                    }
                    if (options.autoHashtags && json.hashtags.length === 0) {
                        this.enhanceCrossedOptions.push(self.enhanceOptionsInfo.autoHashtags)
                        options.autoHashtags = false
                    }
                    if (options.autoEmoji && !self.isEmoji(json.post)) {
                        this.enhanceCrossedOptions.push(self.enhanceOptionsInfo.autoEmoji)
                        options.autoEmoji = false
                    }
                    if (json.linkDetails) {
                        const n = json.linkDetails.filter(x => x.warning)
                        this.linkWarning = n.length > 0
                    }
                    self.showEnhanceOptions(options)
                    if (json.limit) {
                        self.limit = json.limit
                    }
                }).catch((err) => {
                    self.loading = false
                    if (err.response.status === 402) {
                        self.showUpgradeTooltip = true
                        return
                    }
                    const message = err.response && err.response.data.message ? err.response.data.message : 'Something went wrong.'
                    this.$notify({type: 'error', text: message})
                })
            },
            revertEnhancedPost () {
                this.message = this.originalMessage
                this.images = []
                this.diff = []
            },
            compareMessages () {
                this.diff = worddiff.diffString(this.originalMessage, this.message)
            },
            showEnhanceOptions (options) {
                this.enhanceCheckedOptions = []
                Object.keys(this.enhanceOptionsInfo).forEach(key => {
                    if (options[key]) {
                        this.enhanceCheckedOptions.push(this.enhanceOptionsInfo[key])
                    }
                })
            },
            isEmoji (str) {
                const ranges = [
                    '\ud83c[\udf00-\udfff]', // U+1F300 to U+1F3FF
                    '\ud83d[\udc00-\ude4f]', // U+1F400 to U+1F64F
                    '\ud83d[\ude80-\udeff]' // U+1F680 to U+1F6FF
                ]
                return !!str.match(ranges.join('|'))
            },
            setTooltip (option) {
                return `<div class='alert alert-warning'><i class='fa fa-lightbulb-o'></i> ${option.tooltipWhy}</div>
                ${option.tooltip}`
            }
        }
    }
</script>

<style>
    .arrow-top {
        margin-left: 108px
    }
    .image {
        max-width: 200px;
    }
    .results-panel {
        background-color: #f5f5f5;
        padding: 1.5em;
    }
    .remove-text {
        text-decoration: line-through;
        background-color: #d88a8b;
    }
    .add-text {
        background-color: #b6d5a9;
    }
    .enhance-options ul {
        list-style:none;
        line-height: 1.5em;
        padding-left: 1em;
        margin-top: 1em;
    }
    .enhance-options li {
        font-weight: bold;
    }
    .enhance-options li:before {
        font-family: 'FontAwesome',sans-serif;
        margin:0 5px 0 -15px;
        font-size: 0.9em;
    }
    .enhance-options .checked:before {
        content: '\f00c';
        color: #347e2d;
    }
    .enhance-options .crossed:before {
        content: '\f00d';
        color: #ad2d2d;
    }
    .revert:before {
        content: '\f0e2' !important;
        color: #61b2f2 !important;
    }
    .revert a{
        color: #61b2f2;
    }
    .option-info-tooltip {
        color: #61b2f2;
        font-size: 0.9em;
    }
</style>



// WEBPACK FOOTER //
// src/EnhanceComposer.vue